import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { delayTime } from 'shared/constants';
import './ButtonList.scss';
import ArrowUpIcon from 'assets/icons/enter.svg';
import _ from 'lodash';

// import { websocketSend } from '../../data/websocket/websocket';

import Button from '../Button/Button';
import ButtonWithIcon from '../ButtonWithIcon/ButtonWithIcon';
import OptionButton from '../OptionButton/OptionButton';
import SampleIcon from '../../assets/images/avatar.png';

class ButtonList extends Component {
  static propTypes = {
    /** use to display regular buttons (outline & primary) and button w/ icon; by default, it's false to display regular buttons */
    isButtonWithIcon: PropTypes.bool,
    /** if value is true, will display option list */
    isOptionButton: PropTypes.bool,
    /** pass array of object here to populate button with Icon list */
    buttonWithIconList: PropTypes.arrayOf(PropTypes.object),
    /** pass array of object here to populate regular button list */
    buttonList: PropTypes.arrayOf(PropTypes.object),
    /** pass array of object here to populate option list */
    optionList: PropTypes.arrayOf(PropTypes.object),
    /** Is RTL */
    rtl: PropTypes.bool,
    /** onOptionClick */
    onOptionClick: PropTypes.func,
    /** is multiple checkbox */
    isCheckbox: PropTypes.bool,
    /** is input label with translate options */
    translateOptions: PropTypes.objectOf(PropTypes.string),
    //
    defaultSelectedOptions: PropTypes.string,
  }

  static defaultProps = {
    isButtonWithIcon: false,
    isOptionButton: false,
    buttonWithIconList: [
      {
        id: 1,
        icon: SampleIcon,
        title: 'Retirement',
        description: 'Lorem ipsum dolor alamah aiyo teh. lor ban ga lor mee',
        isSelected: false,
      },
      {
        id: 2,
        icon: SampleIcon,
        title: 'Education',
        description: 'Aloha psum dolor alamah aiyo teh. lor ban ga lor mee',
        isSelected: true,
      },
      {
        id: 3,
        icon: SampleIcon,
        title: 'Education',
        description: 'Aloha psum dolor alamah aiyo teh. lor ban ga lor mee',
        isSelected: false,
      },
    ],
    buttonList: [],
    optionList: [],
    rtl: false,
    onOptionClick: () => {},
    isCheckbox: false,
    translateOptions: {},
    defaultSelectedOptions: '',
  }

  state = {
    buttonWithIconList: this.props.buttonWithIconList,
    selectedOption: null,
    selectedOptions: [],
    onClickEvent: null,
    isSelectButtonWithIcon: false,
  }

  buttonClick = (buttonId) => {
    console.log('===> ', buttonId);
  }

  handleUpdateIcon = (index) => {
    const { buttonWithIconList } = this.state;
    for (let i = 0; i < buttonWithIconList.length; i += 1) {
      if (index === i) {
        buttonWithIconList[i].isSelected = true;
      } else {
        buttonWithIconList[i].isSelected = false;
      }
    }
    this.setState(buttonWithIconList);
  }

  render() {
    const {
      isButtonWithIcon, isOptionButton, buttonList, optionList, rtl, intl, isCheckbox, translateOptions, defaultSelectedOptions,
    } = this.props;
    const classes = classNames({
      'nw-group-buttons': true,
      'nw-group-buttons--rtl': rtl,
      'nw-group-buttons--options': isOptionButton || isCheckbox,
      'nw-group-buttons--icons': isButtonWithIcon,
    });
    return (
      <div className={classes}>

        {!isButtonWithIcon && buttonList.map(button => (
          <Button
            value={button.value}
            key={button.id}
            id={button.id}
            isOutlineButton={button.isOutlineButton}
            onButtonClick={() => this.buttonClick(button.id)}
          >
            {button.value}
          </Button>
        ))}

        {isButtonWithIcon && this.state.buttonWithIconList.map((button, index) => (
          <ButtonWithIcon
            key={index}
            noOfButton={this.state.buttonWithIconList.length}
            icon={button.icon}
            title={intl.formatMessage({ id: button.payload })}
            iconActive={button.iconActive}
            isSelected={button.isSelected}
            onButtonClick={() => {
              if (!this.state.isSelectButtonWithIcon) {
                this.setState({ isSelectButtonWithIcon: true }, () => {
                  this.handleUpdateIcon(index);
                  this.props.onButtonClick(button.payload, { icon: button.icon });
                });
              }
            }}
          />

        ))}

        {isOptionButton && optionList.map(option => (
          <OptionButton
            rtl={rtl}
            key={`key-${option.payload}`}
            id={option.payload}
            name={this.props.name}
            // id={`opt-${idx}`}
            // name="radioOptions"
            label={translateOptions && !_.isEmpty(translateOptions)
              ? intl.formatMessage({ id: option.payload }, translateOptions) : intl.formatMessage({ id: option.payload })}
            // label={option.payload}
            onOptionClick={() => {
              this.setState({ selectedOption: option.payload });
              // prevent double submit
              if (this.state.onClickEvent === null) {
                this.setState({
                  onClickEvent: setTimeout(() => this.props.onOptionClick(option.payload), delayTime),
                });
              } else {
                clearTimeout(this.state.onClickEvent);
                this.setState({
                  onClickEvent: setTimeout(() => this.props.onOptionClick(option.payload), delayTime),
                });
              }
            }}
            selected={this.state.selectedOption}
          />
        ))}

        {isCheckbox
        && (
        <Fragment>
          {optionList.map(option => (
            <OptionButton
              rtl={rtl}
              key={`key-${option.text}`}
              id={option.text}
              name={this.props.name}
              label={intl.formatMessage({ id: option.text })}
              onOptionClick={() => {
                let { selectedOptions } = this.state;
                const { text } = option;
                if (text === defaultSelectedOptions) {
                  selectedOptions = defaultSelectedOptions ? [defaultSelectedOptions] : [];
                } else if (selectedOptions.includes(text)) {
                  selectedOptions = selectedOptions.filter(item => item !== text);
                } else {
                  selectedOptions = [...selectedOptions.filter(item => item !== defaultSelectedOptions), text];
                }
                this.setState({ selectedOptions });
              }}
              selected={this.state.selectedOptions}
              isCheckbox
            />
          ))}
          <button
            type="button"
            className={`nw-button nw-button--icon nw-button--submit ${!this.state.selectedOptions.length ? 'nw-button--disabled' : ''}`}
            onClick={() => this.props.onOptionClick(this.state.selectedOptions.join(', '))}
            disabled={!this.state.selectedOptions.length}
          >
            <img src={ArrowUpIcon} alt="Submit" />
          </button>
        </Fragment>
        )
        }

      </div>
    );
  }
}

export default injectIntl(ButtonList);
